import { useUserData } from 'root/src/client/v2/userData/hooks/useUserData';
export function useHasTokens() {
    var _a;
    const { userData } = useUserData();
    if (!Array.isArray(userData === null || userData === void 0 ? void 0 : userData.tokens)) {
        return { hasTokens: false };
    }
    // TODO maybe add loading from user data here?
    const hasTokens = Boolean((_a = userData === null || userData === void 0 ? void 0 : userData.tokens) === null || _a === void 0 ? void 0 : _a.length);
    return {
        hasTokens,
    };
}
